import { $settings } from '@/provider/settings';

const localStorageHelper = {
  setCid: (value) => {
    window.localStorage.setItem('cid', value);
  },

  getCid: () => window.localStorage.getItem('cid') || $settings.cid[0].value,

  setLocale: (value) => {
    window.localStorage.setItem('locale', value);
  },

  getLocale: () =>
    window.localStorage.getItem('locale') || $settings.languages[0].value,

  setProfile: (value) => {
    window.localStorage.setItem('profile', JSON.stringify(value));
  },
  setToken: (value) => {
    window.localStorage.setItem('token', value);
  },
  getToken: () => window.localStorage.getItem('token') || '',
  getProfile: () => {
    const profile = window.localStorage.getItem('profile');
    return (profile && JSON.parse(profile)) || {};
  },
  getTimeStamp: () => {
    const locale = localStorageHelper.getLocale();
    const dateString =
      JSON.parse(window.localStorage.getItem(`metadata-${locale}-timestamp`)) ||
      new Date(1970, 1, 1).toISOString();
    const date = new Date(dateString);
    return date.toISOString();
  },

  setTimeStamp: () => {
    const locale = localStorageHelper.getLocale();
    window.localStorage.setItem(
      `metadata-${locale}-timestamp`,
      JSON.stringify(new Date().toISOString()),
    );
  },

  setItem: (itemName, data) => {
    window.localStorage.setItem(itemName, JSON.stringify(data));
  },

  getItem: (itemName) =>
    JSON.parse(window.localStorage.getItem(itemName)) || {},
};

export default localStorageHelper;
